/*工资表 */
import { $http, buildHeaders } from "./index";

//获取工资表列表
export const payroll_list = (params) => {
  return $http.get("/admin/Payroll/index", { params });
};

//获取工资表详情
export const payroll_detail = (id) => {
  return $http.get("/admin/Payroll/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加工资表
export const payroll_add = (data) => {
  return $http.post("/admin/Payroll/add", data, {
    headers: buildHeaders(3),
  });
};

//修改工资表
export const payroll_edit = (data) => {
  return $http.post("/admin/Payroll/edit", data, {
    headers: buildHeaders(3),
  });
};

//删除工资表
export const payroll_delete = (id) => {
  return $http.post(
    "/admin/Payroll/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取工资发放明细列表
export const payrollemployee_list = (params) => {
  return $http.get("/admin/PayrollEmployee/detail", { params });
};
